/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import './cellular-device-settings.scss';

/* eslint-disable import/no-unresolved, import/default */

import cellularDeviceSettingsTemplate from './cellular-device-settings.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('agrolog.farmer.deviceSettings', [])
    .directive('cellularDeviceSettings', CellularDeviceSettings)
    .name;

/*@ngInject*/
function CellularDeviceSettings() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            ctx: "=",
            device: "="
        },
        controller: CellularDeviceSettingsController,
        controllerAs: 'vm',
        templateUrl: cellularDeviceSettingsTemplate
    };
}

/* eslint-disable angular/angularelement */

/*@ngInject*/
function CellularDeviceSettingsController($scope, $q, $filter, $timeout, types, agUtils, deviceService, attributeService, userService) {// eslint-disable-line

    let vm = this;

    vm.loading = false;
    vm.showData = userService.getAuthority() === 'TENANT_ADMIN' || userService.getAuthority() === 'CUSTOMER_USER';

    vm.origDevice = null;
    vm.deviceAttributes = ["cropType", "latitude", "longitude", "minSampleTemp", "maxSampleTemp", "minAmbientTemp", "maxAmbientTemp", "disableAlarms"];
    vm.cropTypes = ["Oil Rape Seed", "Oats", "Corn", "Wheat", "Durum Wheat", "Barley", "Sorghum", "Soy Bean", "Rice", "Rye", "Peas Yellow"];

    vm.saveSettings = saveSettings;
    vm.cancel = cancel;

    $scope.$watch(() => { return vm.device ? vm.device.name : null; }, (title) => {
        if (vm.ctx && title) {
            vm.ctx.widgetTitle = vm.device.label + ' (' + agUtils.getFarmerDeviceName(vm.device.type) + '): Settings';
            vm.loading = true;
            loadDeviceAttributes(vm.device).then(
                (updatedDevice) => {
                    vm.device = updatedDevice;
                    vm.origDevice = angular.copy(vm.device);
                    vm.loading = false;
                    resetFormState();
                },
                () => {
                    vm.loading = false;
                }
            );
        }
    });

    function loadDeviceAttributes(device) {
        let deferred = $q.defer();
        attributeService.getEntityAttributesValues(device.id.entityType, device.id.id,
            types.attributesScope.server.value, vm.deviceAttributes.join(','), {ignoreLoading: true}).then(
            (serverAttributes) => {
                if (serverAttributes && serverAttributes.length > 0) {
                    for (let i = 0; i < vm.deviceAttributes.length; i++) {
                        let serverKey = vm.deviceAttributes[i];
                        device[serverKey] = getAttributeValue(serverAttributes, serverKey);
                    }
                }
                deferred.resolve(device);
            },
            () => {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function getAttributeValue(attributes, key) {
        let foundAttributes = $filter('filter')(attributes, {key: key}, true);
        if (foundAttributes.length > 0) {
            return foundAttributes[0].value;
        } else {
            return null;
        }
    }

    function saveSettings() {
        let savePromise = (vm.origDevice.label != vm.device.label) ? deviceService.saveDevice(vm.device) : $q.when(null);
        savePromise.then(
            () => {
                let attributes = [];
                for (let i = 0; i < vm.deviceAttributes.length; i++) {
                    let serverKey = vm.deviceAttributes[i];
                    attributes.push({key: serverKey, value: vm.device[serverKey]});
                }
                attributeService.saveEntityAttributes(vm.device.id.entityType, vm.device.id.id,
                    types.attributesScope.server.value, attributes).then(
                    () => {
                        vm.origDevice = vm.device;
                        vm.device = angular.copy(vm.origDevice);
                        resetFormState();
                    }
                );
            }
        );
    }

    function cancel() {
        vm.device = angular.copy(vm.origDevice);
        resetFormState();
    }

    function resetFormState() {
        $timeout(() => {
            $scope.theForm.$setPristine();
            $scope.theForm.$setUntouched();
        });
    }
}